<template>
  <b-container fluid class="py-3">
    <b-row class="position-relative">
      <b-col>
        <SkeletonTableLoader :columns="headers" :loading="loading" />
        <b-row class="datepickerinvoicefield" v-if="showdatefilter">
          <b-col class="d-flex align-items-center gap-3 px-0">
            <div class="field">
              <CustomDatePicker label="From Date" name="From Date" :required-icon="false" id=""
                :rules="{ required: false }" v-model="outstandinginvoice_data.fromdate"
                @date-select="selectinvoicedate()" />
            </div>
            <div class="field">
              <CustomDatePicker label="To Date" name="PrePayment Date" :required-icon="false" id=""
                @date-select="selectinvoicedate()" :rules="{ required: false }"
                v-model="outstandinginvoice_data.todate" />
            </div>
            <span class="cleardate mx-0" @click="cleardate">Clear</span>
            <Button label="Make Payment" @click="submitbtn"
              class="mt-2 p-button-info p-button-sm Footer float-end rounded" />
          </b-col>
        </b-row>
        <div v-if="!loading">
          <MasterEmpty v-if="items.length === 0" eheader="OutStanding Invoice" econtent="OutStanding Invoice"
            eimg="/src/assets/Img/icons/supplier-mapping.svg" :createline="false" />
          <Tableview v-if="items.length !== 0" v-model:value="items" v-model:selection="selectedOutstandingInvoice"
            :paginator="true" class="p-datatable-gridlines inovicetable" :rows="10" :rowHover="true"
            filterDisplay="menu" :loading="loading" responsiveLayout="scroll" :columns="headers" dataKey="ID"
            :selectionMode="true" :addnewbtn="true" FromPage="OutStandingInvoicesTable">
            <template v-slot:PaymentStatusSlot="{ data }">
              <!-- PO PAYMENTS -->
              <OrangeStatus name="Payment Pending" v-if="data.Status == '0' && data.GRNId == 0" />
              <BlueStatus name="Partially Paid" v-if="data.Status == '1' && data.GRNId == 0" />
              <GreenStatus name="Paid" v-if="data.Status == '2' && data.GRNId == 0" />
              <!-- GRN PAYMENTS -->
              <OrangeStatus name="Payment Pending" v-if="data.Status == '2' && data.GRNId != 0" />
              <BlueStatus name="Partially Paid" v-if="data.Status == '3' && data.GRNId != 0" />
              <GreenStatus name="Paid" v-if="data.Status == '1' && data.GRNId != 0" />
            </template>
            <template v-slot:PaymentTermsDescSlot="{ data }">
              {{ data.PaymentTermsDesc === null ? "-" : data.PaymentTermsDesc }}
            </template>
            <template v-slot:PercentageSlot="{ data }">
              {{ data.Percentage === 0 ? "-" : data.Percentage }}
            </template>
            <template v-slot:View="{ data }">
              <div v-for="(item, index) in uploadedTableList" :key="index">
                <div v-if="
                  uploadedTableList.length > 0
                    ? item.uploadId == data.POPaymentId
                    : ''
                " :title="item.fileName" class="d-flex align-items-center">
                  <div>
                    <p class="filenametxt">{{ item.fileName }}</p>
                    <div class="blue-txt" id="file-name" @click="fileviewer(item.fullPath)">
                      View
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </Tableview>
        </div>
      </b-col>
    </b-row>
    <!-- <b-row v-if="!loading && items.length !== 0">
      <b-col>
        <Button label="Make Payment" @click="submitbtn" class="ms-2 p-button-info p-button-sm Footer float-end" />
      </b-col>
    </b-row> -->
  </b-container>
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  computed,
  PropType,
  watch,
  onMounted,
} from "vue";
import Tableview from "../../../../../../components/FormComponents/NormalTable.vue";
import { useRouter, useRoute } from "vue-router";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import SupplierPaymentMasterService from "../../../../../../modules/Inventory/Service/SupplierPaymentMasterService";
import CustomDatePicker from "../../../../../../components/FormComponents/DatePicker.vue";
import moment from "moment";
import PrePaymentCreationPopup from "../../../../../../modules/Inventory/pages/Transaction/Payment/SupplierPayment/PrePaymentCreation.vue";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  components: {
    Tableview,
    SkeletonTableLoader,
    MasterEmpty,
    CustomDatePicker,
  },
  props: {
    datas: {
      type: Array,
      default: [],
    },
    activeIndex: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    //Declaration
    const activeTabIndex = ref(props.activeIndex);
    const router = useRouter();
    const route = useRoute();
    const toast = useToast();
    const selectedOutstandingInvoice: any = ref([]);
    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    const outstandinginvoice_data = ref({
      fromdate: "",
      todate: "",
    });
    let showdatefilter = ref();
    const items: any = ref([]);
    onMounted(async () => {
      // IsShow();
      datepickerloader();
    });
    const loading = ref(false);
    let fullPath = ref();
    let uploadId = ref();
    let uploadedTableList: any = ref([]);
    //DataTable Fields
    const headers = [
      {
        header: "S.No",
        field: "RowNumber",
        class: "filterdisplaynone",
      },
      {
        header: "GRN Code",
        field: "DocNo",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "PO Code",
        field: "POCode",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "Invoice Id",
        field: "InvoiceID",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "Invoice Date",
        field: "InvoiceDate",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
      },
      {
        header: "PaymentTerms",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        slot: "PaymentTermsDescSlot",
        class: "smallwidth",
      },
      // {
      //   header: "Description",
      //   field: "Description",
      //   class: "filterdisplaynone",
      //   bodyclass: "boldclass",
      // },
      {
        header: "Percentage",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        slot: "PercentageSlot",
        class: "smallwidth",
      },
      {
        header: "Amount",
        field: "Amount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
       {
        header: "Paid Amount",
        field: "PaidAmount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "DueAmount",
        field: "DueAmount",
        class: "filterdisplaynone",
        bodyclass: "boldclass",
      },
      {
        header: "View File",
        field: "",
        fieldDisplay: "false",
        slot: "View",
        sortable: false,
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        class: "",
      },
      {
        header: "Payment Status",
        field: "",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        slot: "PaymentStatusSlot",
        class: "smallwidth",
      },
    ];
    let selectedArray: any = ref([]);
    const supplierdatas: any = ref(props.datas);
    watch(
      () => props.datas,
      (newVal: any) => {
        supplierdatas.value = newVal;
        IsShow();
        datepickerloader();
      },
      { deep: true }
    );

    watch(
      () => selectedOutstandingInvoice,
      (newVal: any) => {
        // let data = selectedOutstandingInvoice.value.filter((items) => items.PrePaymentApprovalStatus == 0)
        selectedArray.value = selectedOutstandingInvoice.value.map(
          (item) => item.Id
        );
        // if (data.length != 0) {
        //   toast.add({
        //     severity: "warn",
        //     summary: "Please Approve PrePaymentId : " + data[0].PrepaymentDetails,
        //     detail: "",
        //     life: 3000,
        //   });
        //   selectedOutstandingInvoice.value = selectedOutstandingInvoice.value.filter((items) => items.PrePaymentApprovalStatus != 0)
        // }
      },
      { deep: true }
    );
    watch(
      () => props.activeIndex,
      (newVal: any) => {
        //  emit("invoiceselection", selectedOutstandingInvoice.value.filter((items) => items.PrePaymentApprovalStatus != 0));
        IsShow();
        selectedOutstandingInvoice.value = items.value.filter((item: any) =>
          selectedArray.value.includes(item.Id)
        );

        datepickerloader();
      },
      { deep: true }
    );
    function selectinvoicedate() {
      selectedOutstandingInvoice.value = [];
      IsShow();
    }
    function cleardate() {
      selectedOutstandingInvoice.value = [];
      outstandinginvoice_data.value.fromdate = "";
      outstandinginvoice_data.value.todate = "";
      IsShow();
    }
    async function IsShow() {
      debugger;
      try {
        loading.value = true;
        let count = 0;
        if (
          outstandinginvoice_data.value.fromdate != "" &&
          outstandinginvoice_data.value.fromdate != undefined
        ) {
          outstandinginvoice_data.value.fromdate = moment(
            outstandinginvoice_data.value.fromdate
          ).format("YYYY-MM-DD");
        } else if (
          outstandinginvoice_data.value.fromdate == "" ||
          outstandinginvoice_data.value.fromdate == undefined
        ) {
          outstandinginvoice_data.value.fromdate = "";
        }

        if (
          outstandinginvoice_data.value.todate != "" &&
          outstandinginvoice_data.value.todate != undefined
        ) {
          outstandinginvoice_data.value.todate = moment(
            outstandinginvoice_data.value.todate
          ).format("YYYY-MM-DD");
        } else if (
          outstandinginvoice_data.value.todate == "" ||
          outstandinginvoice_data.value.todate == undefined
        ) {
          outstandinginvoice_data.value.todate = "";
        }
        const dataresponse =
          await SupplierPaymentMasterService.GetOutStandingList(
            supplierdatas.value.SupplierId,
            usersData.OrganizationId,
            usersData.BranchId,
            outstandinginvoice_data.value.fromdate,
            outstandinginvoice_data.value.todate,
            route.query.StoreId
          );
        items.value = dataresponse["result"].map((item: any) => {
          count = count + 1;
          item.RowNumber = count;
          item.Amount = item.Amount.toFixed(2);
          item.DueAmount = item.DueAmount.toFixed(2);
          //  item.TaxAmount = item.DueAmount.toFixed(2);
          item.TaxAmount = item.TaxAmount.toFixed(2);
          return item;
        });
        uploadedTableList.value = [];
        for (let i = 0; i < items.value.length; i++) {
          if (items.value[i]["FileUpload"]) {
            const fileUploads = items.value[i]["FileUpload"].split(",");

            fileUploads.forEach((FileUpload) => {
              const fileName = FileUpload.split("/").pop();
              if (fileName) {
                const fileEntry = {
                  uploadId: items.value[i]["POPaymentId"],
                  fileName: fileName.trim(),
                  fullPath: FileUpload.trim(),
                };
                uploadedTableList.value.push(fileEntry);
              }
            });
          }
        }

        console.log(items.value);

        loading.value = false;
      } catch (error) {
        console.log(error);
      }
    }

    const submitbtn = () => {
      debugger;
      emit("loadactiveindex");
      emit("invoiceselection", selectedOutstandingInvoice.value);
    };
    async function datepickerloader() {
      while (loading.value) {
        await new Promise((resolve) => setTimeout(resolve, 100));
      }
      if (items.value.length !== 0) {
        showdatefilter.value = true;
      } else {
        showdatefilter.value = false;
      }
    }
    function fileviewer(data) {
      debugger;
      const newTabUrl = data;
      window.open(newTabUrl, "_blank");
    }
    return {
      uploadedTableList,
      fileviewer,
      items,
      loading,
      headers,
      supplierdatas,
      IsShow,
      activeTabIndex,
      submitbtn,
      selectedOutstandingInvoice,
      outstandinginvoice_data,
      cleardate,
      showdatefilter,
      selectinvoicedate,
      datepickerloader,
      selectedArray,
      // isRowCheckboxDisabled
    };
  },
});
</script>

<style lang="scss" scoped>
.datepickerinvoicefield {
  max-width: 648px;
  margin-right: 15px;
  position: absolute;
}

.cleardate {
  margin-left: 15px;
  margin-top: 10px;
}
</style>
<style lang="scss">
.inovicetable .p-datatable {
  margin-top: 20px;
}

.disableclass {
  pointer-events: none;
  opacity: 0.5;
}
</style>
